import React from 'react';
import { string, func, number, bool } from 'prop-types';

// Import components
import { PreviewButton } from 'components/views/vod/components/buttons/PreviewButton';
import PlayerTrailer from './PlayerTrailer';

// Import utilities
import useToggle from 'components/utilities/hooks/toggle/useToggle';

const MovieTrailer = ({ uuid, GTMEvent, videoId, isMovieDetails = false }) => {
	const [isOpen, toggle] = useToggle();

	return (
		<>
			<PreviewButton watchPreview={toggle} GTMEvent={GTMEvent} />
			{isOpen && (
				<PlayerTrailer
					uuid={uuid}
					toggle={toggle}
					videoId={videoId}
					isMovieDetails={isMovieDetails}
				/>
			)}
		</>
	);
};

MovieTrailer.propTypes = {
	uuid: string.isRequired,
	GTMEvent: func,
	videoId: number.isRequired,
	isMovieDetails: bool
};

export default MovieTrailer;
